import { SearchOutlined } from '@ant-design/icons';
import React from 'react';
import { MapRef } from 'react-map-gl';
import { FLYOVER_TRANSITION_DURATION } from '../../components/map/omnia_map';
import { OmniaMapSearchSelect } from '../../components/map/omnia_map_search';
import { MapQueryParams } from '../../components/map_default/map_default';
import { WaterbodySelectValue } from '../../components/waterbody_search_select/waterbody_search_select';
import { useQueryString } from '../../hooks/use_query_string';
import { useResponsive } from '../../hooks/use_responsive';
import { fitBounds } from '../../lib/fit_bounds';
import { ExtendedMapQueryParams } from './lib/map_page_types';
import styles from './search_and_filters.less';

interface SearchAndFiltersProps {
  handleModalChange: (val: null) => void;
  isReportsModalOpen: boolean;
  mapDimensions: { width: number; height: number };
  mapRef: MapRef;
}

export const SearchAndFilters = (props: SearchAndFiltersProps) => {
  const { handleModalChange, isReportsModalOpen, mapDimensions, mapRef } = props;

  const { isMobile } = useResponsive();
  const { replaceQueryString } = useQueryString();

  // TODO: this should be move up to map_page
  const handleSelectChange = (newValue: WaterbodySelectValue) => {
    if (!newValue) {
      return;
    }
    const waterbody = newValue.label.props['data-result'];
    const { bbox, lng, lat, url_slug } = waterbody;
    let zoom = 13;

    if (bbox) {
      zoom = fitBounds(
        [
          [bbox[0][0], bbox[1][1]],
          [bbox[2][0], bbox[3][1]],
        ],
        {
          width: mapDimensions.width,
          height: mapDimensions.height,
        }
      ).zoom;
    }
    mapRef.flyTo({
      center: [lng, lat],
      zoom,
      duration: FLYOVER_TRANSITION_DURATION - 1000,
    });
    if (isMobile && isReportsModalOpen) {
      handleModalChange(null);
    }
    replaceQueryString<ExtendedMapQueryParams>({
      [MapQueryParams.waterbody_slug]: url_slug,
    });
  };

  return (
    <>
      <div className={styles.searchWrapper}>
        <div className={styles.search}>
          <OmniaMapSearchSelect
            allowClear
            showSearch
            suffixIcon={<SearchOutlined />}
            placeholder={'Search by Lake'}
            onSelect={handleSelectChange}
            dropdownStyle={{ zIndex: 399 }}
          />
        </div>
      </div>
    </>
  );
};
